import { Onderdeel } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Risicoscan, {
  onderdeel: Onderdeel.Risicoscan,
  isVisible: (settings: EnvironmentSettings) =>
    (settings.isActiveAdviseur || settings.isInterneGebruiker) && settings.heeftRisicoscanPermissie,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Risicoscan,
    title: 'Risicoscan',
    url: '/app/aanvraag/risicoscan',
    iconclass: 'fas fa-wrench',
    target: '_top',
  }),
});
